// tslint:disable-next-line:no-var-requires
require('dotenv').config({ path: '../../.env' })
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import './styles/reset.css'

ReactDOM.render(<App />, document.getElementById('root') as HTMLElement)
